import {Component, Input} from "@angular/core";
import {WarrantyLru} from "../../../json/warranty-lru";

@Component({
	selector: "panel-mount-registration-lrus-table",
	template: `
		<table *ngIf="lrus && lrus.length > 0" class="warrantyregistration_panel_review_table">
			<thead>
				<tr>
					<th>Item Name</th>
					<th>Item Number</th>
					<th>Serial Number</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let lru of lrus">
					<td>{{lru.description}}</td>
					<td>{{lru.partNumber}}</td>
					<td>{{lru.serialNumber}}</td>
				</tr>
			</tbody>
		</table>
	`,
})
export class PanelMountRegistrationLrusTableComponent {
	@Input() lrus: Array<WarrantyLru>;
}
